import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
interface UseFiltersOffsetResult {
  top_offset: number;
}
const useFiltersOffset = base_offset => {
  const $ = _c(4);
  const [filters_height, setFiltersHeight] = useState(28);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const filters_form = document.getElementById("filters-form");
      if (!filters_form) {
        return;
      }
      const updateHeight = () => {
        const height = filters_form.getBoundingClientRect().height;
        setFiltersHeight(height);
      };
      updateHeight();
      const resize_observer = new ResizeObserver(() => {
        updateHeight();
      });
      resize_observer.observe(filters_form);
      return () => {
        resize_observer.disconnect();
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = base_offset + filters_height;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      top_offset: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default useFiltersOffset;